import type { Map as MapLibreMap } from "maplibre-gl"

export type LayerOrderConstraint = {
    above?: string[]
    below?: string[]
}

export function resolveBeforeId(
    map: MapLibreMap,
    { above = [], below = [] }: LayerOrderConstraint
): string | undefined {
    const layers = map.getStyle()?.layers ?? []
    const indexOf = new Map(layers.map((layer, index) => [layer.id, index]))

    let lowerBound = -1
    for (const id of above) {
        const index = indexOf.get(id)
        if (index !== undefined) lowerBound = Math.max(lowerBound, index)
    }

    let upperBound = layers.length
    for (const id of below) {
        const index = indexOf.get(id)
        if (index !== undefined) upperBound = Math.min(upperBound, index)
    }

    // conflicting constraints: stay below rather than above
    const insertIndex = Math.min(lowerBound + 1, upperBound)
    return insertIndex < layers.length ? layers[insertIndex].id : undefined
}

export const BASEMAP_RASTER_LAYER_IDS = ["Hillshade", "Satellite Mediumres 2021", "Satellite"]

export const BASEMAP_WATER_FILL_LAYER_IDS = ["Water shadow", "Water"]

const OVERLAY_STACK_ORDER_BOTTOM_TO_TOP: readonly (readonly string[])[] = [
    ["elevation"],
    ["geostationary"],
    ["fire-danger-ca", "fire-danger-us"],
    ["civilization"],
]

export function overlaysBelow(sourceId: string): string[] {
    const tierIndex = OVERLAY_STACK_ORDER_BOTTOM_TO_TOP.findIndex((tier) => tier.includes(sourceId))
    if (tierIndex <= 0) return []
    return OVERLAY_STACK_ORDER_BOTTOM_TO_TOP.slice(0, tierIndex)
        .flat()
        .map((id) => `${id}-raster`)
}
